<template>
  <form-row :model-items="modelItems" :all-parametrs="{ disabled: true }" />
</template>

<script>
import { componentMixin } from '@/mixins/document/component';

import FormRow from './FormRow';

// @vuese
// Disabled values component
// // @Group detailsComponents
export default {
  components: {
    FormRow
  },
  mixins: [componentMixin]
};
</script>
